import React from 'react';

export const renderTextWithIndexedTags = (
  text: string,
  elements: React.ReactElement[]
): React.ReactNode => {
  const parts = text.split(/(<\d+>.*?<\/\d+>)/);

  return parts.map((part) => {
    const match = part.match(/<(\d+)>(.*?)<\/\1>/);
    if (match) {
      const index = parseInt(match[1], 10);
      const content = match[2];
      return elements[index]
        ? React.cloneElement(elements[index], { key: `tag-${index}` }, content)
        : content;
    }
    return part;
  });
};
